import { fromJS } from 'immutable';
import {
  SET_UPLOADED_DOCUMENT,
  RESET_UPLOAD_DOCUMENT_STORE,
  SET_DOCUMENT_ID,
  SET_DOCUMENTUM_ID,
} from 'containers/UploadDocuments/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface UploadDocumentsAction {
  type: string;
  uploadedDocument: any;
  documentId: string;
  documentumId: string | null;
}

const initState = fromJS({
  uploadedDocument: {},
  documentId: '',
  documentumId: null,
});

const uploadDocumentsReducer = (
  state = initState,
  action: UploadDocumentsAction,
) => {
  switch (action.type) {
    case SET_UPLOADED_DOCUMENT:
      return state.set('uploadedDocument', fromJS(action.uploadedDocument));
    case SET_DOCUMENT_ID:
      return state.set('documentId', fromJS(action.documentId));
    case SET_DOCUMENTUM_ID:
      return state.set('documentumId', fromJS(action.documentumId));
    case RESET_UPLOAD_DOCUMENT_STORE:
      return initState;
    case RESET_STORE || RESET_UPLOAD_DOCUMENT_STORE:
      return initState;
    default:
      return state;
  }
};
export default uploadDocumentsReducer;
